// extracted by mini-css-extract-plugin
export const page = "mainlayout-module--page--1EGdC";
export const mainContainerDiv = "mainlayout-module--mainContainerDiv--2iWhD";
export const headerDiv = "mainlayout-module--headerDiv--3JP4k";
export const logoImg = "mainlayout-module--logoImg--2iyfN";
export const headerLeftDiv = "mainlayout-module--headerLeftDiv---zMST";
export const headerCenterDiv = "mainlayout-module--headerCenterDiv--OASU7";
export const headerRightDiv = "mainlayout-module--headerRightDiv--1wcoM";
export const comingSoon = "mainlayout-module--comingSoon--3Bqmb";
export const cardscontainer = "mainlayout-module--cardscontainer--37u-W";
export const card = "mainlayout-module--card--3LpUZ";
export const cardImg = "mainlayout-module--cardImg--1M9Dq";
export const link = "mainlayout-module--link--3V4R3";
export const helpLinks = "mainlayout-module--helpLinks--1DC8x";
export const helpHeading = "mainlayout-module--helpHeading--1Jrdw";